import { createSelector } from "@reduxjs/toolkit";
import { GeneratorStoreState } from "./configureGeneratorStore.js";
import { StoreState } from "./configureStore.js";

export const createAppSelector = createSelector.withTypes<StoreState>();
export const createGeneratorSelector =
  createSelector.withTypes<GeneratorStoreState>();
